<template>
  <DxDataGrid id="cabinet-grid"
              :data-source="cabinetList"
              key-expr="cabinet_id"
              :no-data-text="'No cabinets assigned to your account.'"
              :show-column-lines="false"
    >
      <DxColumn cell-template="cabinet-icon" :width="90"/>
      <DxColumn data-field="name" cell-template="cabinet-name" :min-width="250"/>
      <DxColumn caption="Owner" data-field="owner_username" width="auto"/>
      <DxColumn caption="Documents" data-field="documents_count" alignment="right" width="auto"/>
      <DxColumn caption="Last Update" data-field="updated_at" width="auto" :calculate-display-value="convertTimestamp"/>
      <DxColumn cell-template="cabinet-controls" caption='' :width="150"/>

      <template #cabinet-icon="{ data: cellInfo }">
        <CabinetIcon :cabinet-id="cellInfo.data.cabinet_id" :cabinet-name="cellInfo.data.name" :color="cellInfo.data.color"/>
      </template>

      <template #cabinet-name="{ data: cellInfo }">
        <ClickableCabinetName :cabinet-id="cellInfo.data.cabinet_id"
                              :cabinet-name="cellInfo.value"
                              :cabinet-description="cellInfo.data.description"
                              :data="cellInfo"
        />
      </template>

      <template #cabinet-controls="{ data: cellInfo }">
        <CabinetShortcutButtons :cabinet-id="cellInfo.data.cabinet_id"/>
      </template>
    </DxDataGrid>
</template>

<script setup>
  import CabinetIcon from "@/components/cabinets-page/CabinetIcon.vue";
  import CabinetShortcutButtons from "@/components/cabinets-page/CabinetShortcutButtons.vue";
  import ClickableCabinetName from "@/components/cabinets-page/ClickableCabinetName.vue";
  import { DxDataGrid, DxColumn } from 'devextreme-vue/data-grid'
  import moment from 'moment'
  import { storeToRefs } from "pinia";
  import { useCabinetsPageStore } from "@/stores/cabinetsPageStore.js";

  const cabinetsPageStore = useCabinetsPageStore()
  const { cabinetList } = storeToRefs(cabinetsPageStore)

  const convertTimestamp = (rowData) => {
    return moment(rowData.updated_at).fromNow()
  }
</script>

<style lang="scss">
  #cabinet-grid {
    margin-top: 0.5rem;

    .dx-datagrid {
      border: 0.0625rem solid #ddd;
      border-radius: 0.625rem;
      .dx-data-row {
        border-bottom: 0.0625rem solid #ddd;
      }
      .dx-row:nth-child(2) {
        border-bottom: 0;
      }
      .dx-data-row:hover {
        background-color: #F1F1F1;
      }
    }
  }
</style>
